import clsx from 'clsx';
import Txt from 'components/atoms/Txt/Txt';
import React, { FormEventHandler, MouseEventHandler } from 'react';
import classes from './RadioButton.module.scss';

export interface Props {
  value: string;
  name: string;
  label: string;
  defaultChecked?: boolean;
  skipTranslation?: boolean;
  onClick?: MouseEventHandler<HTMLLabelElement> | undefined;
  onInput?: FormEventHandler<HTMLInputElement> | undefined;
  className?: string;
  inputClassName?: string;
  labelClassName?: string;
}

const RadioButton: React.FC<Props> = ({
  name,
  value,
  label,
  defaultChecked,
  onClick,
  onInput,
  skipTranslation,
  className,
  inputClassName,
  labelClassName,
}) => {
  return (
    <label className={clsx(classes.root, className)} onClick={onClick}>
      <input
        type="radio"
        name={name}
        value={value}
        defaultChecked={defaultChecked}
        onInput={onInput}
        className={inputClassName}
      />
      <Txt className={clsx(classes.label, labelClassName)} skipTranslation={skipTranslation}>
        {label}
      </Txt>
    </label>
  );
};

export default RadioButton;
